/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
 apiUrl:"https://api.lbnp.aarambh.cloud",
    subscriberId: 'lbnp-adapter.og-prod.aarambh.cloud',

  adminOrgId: '7681ea00-4b9d-44a3-85d2-3d233694df8f',
    firebaseConfig: {
    apiKey: "AIzaSyDAD5rhEi4BvBdLDMqdZhJunTygiFXxlAQ",
    authDomain: "merchant-aarambh-app.firebaseapp.com",
    projectId: "merchant-aarambh-app",
    storageBucket: "merchant-aarambh-app.firebasestorage.app",
    messagingSenderId: "910223819201",
    appId: "1:910223819201:web:e0957bd550ba2df6b62f40"
  }
};


